import * as React from "react";

const SvgCursorsDragLeft = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      fillOpacity={0.92}
      fillRule="evenodd"
      d="M12.935 2v7.508h-1.299V4.675L4 12.015l7.636 7.363v-4.884h1.299V22H18V2z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.182 3.25v7.5h-3.844v-2.8l-4.225 4.064 4.225 4.029v-2.818h3.844v7.5h2.52V3.25z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCursorsDragLeft;
